export const resetDeliveryArea = (): void => {
  sessionStorage.setItem('polygon', JSON.stringify({}));
  sessionStorage.setItem('circle', JSON.stringify({}));
};
